import React from 'react';

const BlogNewsletter = () => (
  <section className="py-20 bg-gradient-to-r from-amber-500/10 to-orange-500/10 backdrop-blur-sm border-y border-amber-500/20">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
      <h2 className="text-4xl font-bold text-white">
        Stay
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500"> Informed</span>
      </h2>
      <p className="text-xl text-slate-300 leading-relaxed">
        Subscribe to our newsletter for the latest industry insights, tips, and exclusive training offers
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
        <input
          type="email"
          placeholder="Enter your email"
          className="flex-1 px-4 py-3 bg-slate-700 text-white rounded-lg border border-slate-600 focus:border-amber-500 focus:outline-none"
        />
        <button className="bg-gradient-to-r from-amber-500 to-orange-500 text-slate-900 px-6 py-3 rounded-lg font-semibold hover:from-amber-400 hover:to-orange-400 transition-all duration-200">
          Subscribe
        </button>
      </div>
      <p className="text-slate-400 text-sm">
        No spam, unsubscribe at any time. We respect your privacy.
      </p>
    </div>
  </section>
);

export default BlogNewsletter;
